import * as Yup from 'yup';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, FormProvider } from 'react-hook-form';

import Button from 'core/buttons/Button';
import AuthFormWrapper from 'core/forms/AuthFormWrapper';
import FormTextField from 'hook-form-controls/FormTextField';

import app from 'app/config/app';
import { buildRoute } from 'routes';

const schema = Yup.object().shape({
  email: Yup.string().email('Enter a valid email address').required('Enter a email address'),
});

function ForgotPasswordForm({ onSubmit, isProcessing, errors: formErrors }) {
  const methods = useForm({
    defaultValues: {
      ...(app.isDevelopmentMode()
        ? {
            email: 'milantarami.dev@gmail.com',
          }
        : {}),
    },
    resolver: yupResolver(schema),
  });

  const { formState, handleSubmit, getValues } = methods;

  const errors = { ...formState.errors, ...formErrors };

  const handleOnSubmit = () => onSubmit(getValues('email'));

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(handleOnSubmit)}>
        <AuthFormWrapper
          title="Forgot Password"
          subtitle="Please enter your email address and we'll send you instructions on how to reset your password"
        >
          <Grid container rowSpacing={2}>
            <Grid item xs={12}>
              <FormTextField
                label="Email Address"
                name="email"
                error={!!errors?.email}
                helperText={errors?.email?.message ?? ''}
                size="large"
                variant="standard"
              />
            </Grid>
            <Grid item xs={12}>
              <Button type="submit" size="large" disabled={isProcessing} fullWidth>
                {isProcessing ? 'Processing' : 'Reset Password'}
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Link to={buildRoute('login')}>
                <Typography variant="body1">Back to Login</Typography>
              </Link>
            </Grid>
          </Grid>
        </AuthFormWrapper>
      </form>
    </FormProvider>
  );
}

export default ForgotPasswordForm;

ForgotPasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isProcessing: PropTypes.bool.isRequired,
  errors: PropTypes.object,
};
